import React from "react";
import ProspectTenantCard from "../../../listings/listing-cards/prospect-tenant";
import ServiceRequest from "../../../../pages/service-request";
import { useParams } from "react-router-dom";
import { EntityType } from "@propertelligent/client-api";
 
interface ServiceRequestTabContentProps {
   entityTypeId? : number
   onServiceRequestAdded?: () => void;
   tenantUnitId?: number | null;
 }

 const ServiceRequestTabContent: React.FC<ServiceRequestTabContentProps> = ({entityTypeId, onServiceRequestAdded, tenantUnitId}) => {

  const { id } = useParams();
 
    return (
      <ServiceRequest isEntity={true} entityTypeId={entityTypeId} entityId={Number(id)} className="m-0 ServiceRequest-title-heading" 
      onServiceRequestAdded={onServiceRequestAdded} // Pass the callback
      tenantUnitId={tenantUnitId}
      />
    )
}


export default ServiceRequestTabContent;